"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitSyncDatasetDistributorIndexing = void 0;
const routes_1 = require("../../routes");
const submitSyncDatasetDistributorIndexing = (client) => async (distributorId, { productIds }) => {
    const url = routes_1.ENDPOINTS.SUBMIT_DATASET_PARTNER_SYNC_INDEXING_TASK.applyParams(distributorId);
    const { data } = await client.post(url, { productIdList: productIds });
    return data;
};
exports.submitSyncDatasetDistributorIndexing = submitSyncDatasetDistributorIndexing;
